/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Multiview_Source_Groups_HelpInputs */



/**
* | output |
* | --- |
* | "Select two or more event groups to combine. Selection order determines the track order." |
*
* @param {Multiview_Source_Groups_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const multiview_source_groups_help = /** @type {((inputs?: Multiview_Source_Groups_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Multiview_Source_Groups_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez au moins deux groupes d'événements à combiner. L'ordre de sélection détermine l'ordre des parcours.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie zwei oder mehr Ereignisgruppen aus, die Sie kombinieren möchten. Die Auswahlreihenfolge bestimmt die Reihenfolge der Tracks.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona due o più gruppi di eventi da combinare. L'ordine di selezione determina l'ordine delle tracce.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите две или более групп событий для объединения. Порядок выбора определяет порядок треков.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione dos o más grupos de eventos para combinarlos. El orden de selección determina el orden de las pistas.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择两个或多个赛事组进行合并。选择顺序决定赛道顺序。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("結合するイベントグループを2つ以上選択してください。選択順序によってトラックの順序が決まります。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संयोजन के लिए दो या अधिक इवेंट समूहों का चयन करें। चयन का क्रम ट्रैक क्रम निर्धारित करता है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione dois ou mais grupos de eventos para combinar. A ordem de seleção determina a ordem das pistas.")
	return /** @type {LocalizedString} */ ("Select two or more event groups to combine. Selection order determines the track order.")
});